<template>
  <v-container>
    <v-card flat color="transparent" class="mt-7">
      <v-toolbar class="bdr secondary2light" :elevation="0" outlined>
        <v-toolbar-title>{{$t('animal.feedInfo')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon large disabled>
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>

    <v-form ref="form" v-model="isFormValid">
      <v-card flat class="mt-7 pa-5">
        <v-card flat color="transparent" class="mt-7">
          <v-row v-for="(feedObj, index) in feeds" :key="index">
            <v-col cols="12" md="3">
              <div class="text-subtitle-1">
                {{ index > 0 ? $t('animal.feedsName') : $t('animal.feedName')}}
                <v-tooltip top color="black" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" dense>
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>{{$t('animal.feedsName')}}</span>
                </v-tooltip>
              </div>
              <v-text-field
                :placeholder="$t('animal.greenFodderHayLegumes')"
                outlined
                dense
                background-color="white"
                class="mt-2"
                v-model="feedObj.feedName"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <div class="text-subtitle-1">
                {{$t('animal.feedQuantity')}}
                <v-tooltip top color="black" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" dense>
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>{{$t('animal.feedQuantity')}}</span>
                </v-tooltip>
              </div>
              <v-text-field
                placeholder="e.g. 123"
                outlined
                dense
                type="number"
                background-color="white"
                class="mt-2"
                v-model="feedObj.feedQty"
              ></v-text-field>
            </v-col>

            <v-col cols="4" md="2">
              <div class="text-subtitle-1">
                {{$t('units')}}
                <v-tooltip top color="black" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" dense>
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>{{$t('units')}}</span>
                </v-tooltip>
              </div>
              <!-- label="Unit" -->
              <v-select
                :items="weightUnits"
                :placeholder="$t('unit')"
                dense
                outlined
                background-color="white"
                class="mt-2"
                v-model="feedObj.feedUom"
                item-text="name"
                item-value="unit"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <div class="text-subtitle-1">
                {{$t('notes')}}
                <v-tooltip top color="black" max-width="350">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" dense>
                      mdi-help-circle-outline
                    </v-icon>
                  </template>
                  <span>{{$t('notes')}}</span>
                </v-tooltip>
              </div>
              <v-text-field
                outlined
                dense
                class="mt-2"
                v-model="feedObj.note"
                :append-outer-icon="index > 0 ? 'mdi-close': ''"
                @click:append-outer="deleteFeed(index)"
              ></v-text-field>
              <!-- <v-icon v-if="index > 0" @click="deleteFeed(index)" color="red">mdi-close</v-icon> -->
            </v-col>
            <!-- <v-col cols="12" md="1" class="mt-10">
              <v-btn
                v-if="index > 0"
                depressed
                color="primary"
                small
                @click="deleteFeed(index)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col> -->
          </v-row>
          <v-row class="mt-2">
            <v-col class="d-flex mt-n7" cols="12" sm="3" md="3">
              <v-btn depressed color="primary" @click="addNewFeed">
                {{$t('animal.additionalFeed')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <div class="d-flex justify-end">
          <v-btn
            @click="cancelpage"
            outlined
            right
            height="44"
            width="116"
            color="primary"
            class="mr-2 mt-15"
          >
            {{$t('cancel')}}
          </v-btn>
          <v-btn
            right
            class="mt-15"
            height="44"
            width="116"
            color="primary"
            @click="registerFeed()"
          >
            {{$t('submit')}}
          </v-btn>
        </div>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import AnimalService from "@/_services/AnimalService";
import loading from "@/mixins/LoadingMixin";
import { weightUnits } from "@/models/units.js";

export default {
  components: {},
  watch: {
    tableOptions: {
      handler() {
        this.getFeedInfoData();
      },
      deep: true,
    },
  },
  created() {},
  computed: {
    animalNumber: function () {
      return this.$route.params.animal_number;
    },
  },
  data() {
    return {
      isFormValid: false,
      animal: {},
      from: 0,
      to: 0,
      totalPages: 1,
      pageCount: 0,
      tab: null,
      search: "",
      itemsPerPage: 10,
      loading: false,
      tableOptions: {},
      totalFeedInfo: 0,
      feeds: [{ feedName: "", feedQty: "", feedUom: "", note: "" }],
      unitItems: ["kg"],
      weightUnits,
    };
  },

  methods: {
    registerFeed() {
      if (this.$refs.form.validate()) {
        this.startLoading();

        AnimalService.registerFeed({
          feeds: this.feeds,
          animalNumber: this.animalNumber,
        })
          .then((res) => {
            this.feeds = [{ feedName: "", feedQty: "", feedUom: "", note: "" }];
            // res = res.data;

            if (res.success) {
              this.$notify({
                title: this.$t('animal.feedsRegisteredSuccessfully'),
                text: res.message,
                type: "success",
                position: "top right",
              });
              this.cancelpage();
            } else {
              this.$notify({
                title: this.$t('animal.feedsNotRegistered'),
                text: res.message,
                type: "error",
                position: "top right",
              });
            }
            this.stopLoading();
          })
          .catch((err) => {
            this.$notify({
              title: this.$t('animal.feedsNotRegistered'),
              text: err.message,
              type: "error",
              position: "top right",
            });
            console.log(err);
            this.stopLoading();
          });
      }
    },
    addNewFeed() {
      this.feeds.push({ feedName: "", feedQty: "", feedUom: "", note: "" });
    },
    deleteFeed(index) {
      if (index !== 0) {
        this.feeds.splice(index, 1);
      }
    },
    cancelpage() {
      this.$router.push({
        name: "AnimalFeedInfo",
        params: { animal_number: this.$route.params.animal_number },
      });
    },
  },
  mixins: [loading],
};
</script>
<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
.v-list-item__title,
.v-list-item__subtitle {
  white-space: normal;
}

::v-deep .v-icon.v-icon.v-icon--link {
  color: #C54E57;
  font-size: 16px;
}
</style>
